export default theme => ({
    container: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: theme.breakpoints.values.sm,
        },
        backgroundColor: theme.palette.secondary.main
    },
});